'use client'

import { ProductCardConsumerLayoutContext } from 'product-card/context/ProductCardConsumerLayoutContext'
import { useContext } from 'react'

export const useProductCardConsumerLayoutContext = () => {
	const productCardConsumerLayoutContext = useContext(
		ProductCardConsumerLayoutContext
	)

	if (!productCardConsumerLayoutContext) {
		return {
			consumerLayout: null,
			columnsLayout: null,
			setColumnsLayout: null,
			isOnPLP: null,
			isOneColumn: null,
			isTwoColumns: null,
			isFourColumns: null,
		}
	}

	return productCardConsumerLayoutContext
}
